import script from "./AccountDeletionConfirmation.vue?vue&type=script&setup=true&lang=ts"
export * from "./AccountDeletionConfirmation.vue?vue&type=script&setup=true&lang=ts"

import "./AccountDeletionConfirmation.vue?vue&type=style&index=0&id=6366f1fc&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6366f1fc"]])

export default __exports__